const PlaceCenter = ({ children }) => {
    return (
        <div className="place-center">
            {children}
        </div>
    )
}

export default PlaceCenter;